import type React from 'react';
import { Select } from '../../select';
import { Item, type ItemProperties } from '../item';

export type SelectInputProperties<T> = {
  'data-test-id'?: string;
  getOptionLabel: (option: T) => string;
  getOptionValue: (option: T) => boolean | number | string;
  options: T[];
} & Omit<React.ComponentProps<typeof Select>, 'css' | 'options'>;

export type SelectItemProperties = {
  'data-test-id'?: string;
  hidden?: boolean;
  label?: string;
} & ItemProperties;

type P<T> = {
  input: SelectInputProperties<T>;
  item: SelectItemProperties;
};

// TODO selected items in multiple select should be 12px, now are 14px
/**
 * @deprecated
 *
 * Don't use this component since it is "Form.Item + Select" component wrapped in one.
 *
 * Use separate "Form.Item" and "Select" / "OptionSelect" component instead as in FE Admin repository
 *
 */
const SelectInput = <T,>({ input: { getOptionLabel, getOptionValue, options, ...restInput }, item }: P<T>) => (
  <Item {...item}>
    <Select
      {...restInput}
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      data-test-id={item?.['data-test-id']}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      filterOption={(input, option) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    >
      {options.map((option) => (
        <Select.Option
          id={`option_${getOptionValue(option)}`}
          key={String(getOptionValue(option))}
          value={getOptionValue(option)}
        >
          {getOptionLabel(option)}
        </Select.Option>
      ))}
    </Select>
  </Item>
);

export default SelectInput;
